import React from 'react';
import Video from './VideoBackground';
import Image from './ImageBackground';
import { connect } from 'react-redux';

const Background = ({type, background}) => {
    if(type === 'video') {
        return <Video src={background}/>;
    }
    return <Image src={background}/>
}


const mapStateToProps = (state: State) => ({
    type: state.domainProperties.get('backgroundType'),
    background: state.domainProperties.get('background')
});
export default connect(mapStateToProps, null)(Background);


// WEBPACK FOOTER //
// ./src/components/background/Background.jsx